import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin(ScrollToPlugin);

import valueCheck from './modules/util/valueCheck';
import './common'

export default class Contact {
  /**
   * Creates an instance of Contact.
   */
  constructor() {
    $(document).on('keydown', '#new_inquiry input', (e) => {
      if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
          return false;
      } else {
          return true;
      }
    });
    const btnConfirm = document.querySelector('.btn__confirm');
    if (btnConfirm) {
      btnConfirm.addEventListener('click', () => {
        const validateEl = document.querySelectorAll('.validate-target');
        validateEl.forEach((el) => {
          el.querySelectorAll('.control-value').forEach((item) => {
            if (valueCheck(item)) {
              item.parentElement.classList.remove('error');
              item.parentElement.classList.add('correct');
            } else {
              item.parentElement.classList.remove('correct');
              item.parentElement.classList.add('error');
            }
            let count = 0;
            el.querySelectorAll('.col').forEach((a) => {
              if (a.classList.contains('error')) {
                count++;
              }
            });
            if (count > 0) {
              item.parentElement.parentElement.querySelector('p.msg-error').style.display = 'block';
            } else {
              item.parentElement.parentElement.querySelector('p.msg-error').style.display = 'none';
            }
          });
        });
        const errorEl = document.querySelectorAll('.validate-target .col.error');
        if (errorEl.length > 0) {
          const offset = errorEl[0].offsetTop - document.getElementById('header').clientHeight - 50;
          gsap.to(window, 1, { duration: 2, scrollTo: offset });
          return false;
        }
        createModalDetail();
      });
    }
    validation();
  }
}

const validation = () => {
  const validateEl = document.querySelectorAll('.validate-target');
  validateEl.forEach((el) => {
    el.querySelectorAll('.control-value').forEach((item) => {
      item.addEventListener('change', () => {
        if (valueCheck(item)) {
          item.parentElement.classList.remove('error');
          item.parentElement.classList.add('correct');
        } else {
          item.parentElement.classList.remove('correct');
          item.parentElement.classList.add('error');
        }
        let count = 0;
        el.querySelectorAll('.col').forEach((a) => {
          if (a.classList.contains('error')) {
            count++;
          }
        });
        if (count > 0) {
          item.parentElement.parentElement.querySelector('p.msg-error').style.display = 'block';
        } else {
          item.parentElement.parentElement.querySelector('p.msg-error').style.display = 'none';
        }
      });
    });
  });
};

const createModalDetail = () => {
  const modal = document.querySelector('.bModal');
  const modalClose = document.querySelector('.bModal__close');
  const modalDecide = document.querySelector('.js-back');
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
  const closeModal = () => {
    modal.classList.remove('open');
    document.body.style.overflow = 'inherit';
  };
  modalClose.addEventListener('click', closeModal);
  modalDecide.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal();
  });
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      closeModal();
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  new Contact();
});


const $fieldWorkCompany = $('.field-work_company');
const $fieldFullName = $('.field-full_name');
const $fieldEmail = $('.field-email');
const $fieldTel = $('.field-tel');
const $fieldContent = $('.field-content');
const $jsConfirmBtn = $('.js-confirm-btn');
const $jsConfirmWorkCompany = $('.js-confirm-company_name');
const $jsConfirmFullName = $('.js-confirm-full_name');
const $jsConfirmEmail = $('.js-confirm-email');
const $jsConfirmTel = $('.js-confirm-tel');
const $jsConfirmContent = $('.js-confirm-content');
const $jsSubmit = $('.js-submit');
$jsConfirmBtn.on('click', function(e){
  e.preventDefault();
  $jsConfirmWorkCompany.text($fieldWorkCompany.val());
  $jsConfirmFullName.text($fieldFullName.val());
  $jsConfirmEmail.text($fieldEmail.val());
  $jsConfirmTel.text($fieldTel.val());
  $jsConfirmContent.html($fieldContent.val().replace(/\r?\n/g, '<br>'));
});

$jsSubmit.on('click', function(e){
  e.preventDefault();
  $('#new_inquiry').off('submit');
  $('#new_inquiry').submit();
});
